<template>
    <div>
        <form v-if="!calculated" @submit.prevent="submit">
            <div class="form-group">
                <label>Home Price (USD):</label>
                <input
                    type="text"
                    v-model="form.homePrice"
                    :class="['form-control', form.errors.homePrice ? 'is-invalid' : '']"
                    placeholder="Enter home price"
                />
                <div v-text="form.errors.homePrice" class="invalid-feedback" />
            </div>

            <div class="form-group">
                <label>Down Payment (USD):</label>
                <input
                    type="text"
                    v-model="form.downPayment"
                    :class="['form-control', form.errors.downPayment ? 'is-invalid' : '']"
                    placeholder="Enter down payment"
                />
                <div v-text="form.errors.downPayment" class="invalid-feedback" />
            </div>

            <div class="form-group">
                <label>Loan Tenure (Years):</label>
                <input
                    type="text"
                    v-model="form.loanTerm"
                    :class="['form-control', form.errors.loanTerm ? 'is-invalid' : '']"
                    placeholder="Enter loan term in years"
                />
                <div v-text="form.errors.loanTerm" class="invalid-feedback" />
            </div>

            <div class="form-group">
                <label>Annual Interest Rate (%):</label>
                <input
                    type="text"
                    v-model="form.annualRate"
                    :class="['form-control', form.errors.annualRate ? 'is-invalid' : '']"
                    placeholder="Enter annual interest rate"
                />
                <div v-text="form.errors.annualRate" class="invalid-feedback" />
            </div>

            <div class="form-group">
                <button
                    type="submit"
                    :class="['btn btn-primary btn-block', form.loading ? 'btn-loading' : '']"
                >
                    Calculate
                </button>
            </div>
        </form>

        <div v-if="calculated" class="result-container slide-in-left mt-4">
            <div class="alert alert-info text-center">
                <h6 class="font-weight-400">
                    Your estimated monthly payment is <b>{{ result.monthlyPayment }}</b>.
                </h6>
            </div>
            <button
                @click="reset"
                class="btn btn-secondary btn-block"
            >
                Perform Another Calculation
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                homePrice: '',
                downPayment: '',
                loanTerm: '',
                annualRate: '',
                errors: {}, // Reactive object for form errors
                loading: false,
            },
            calculated: false,
            result: { monthlyPayment: 0 },
        };
    },
    methods: {
        validateForm() {
            this.form.errors = {};

            if (!this.form.homePrice || isNaN(this.form.homePrice) || parseFloat(this.form.homePrice) <= 0) {
                this.form.errors.homePrice = 'Please enter a valid home price.';
            }

            if (!this.form.downPayment || isNaN(this.form.downPayment) || parseFloat(this.form.downPayment) < 0) {
                this.form.errors.downPayment = 'Please enter a valid down payment.';
            }

            if (!this.form.loanTerm || isNaN(this.form.loanTerm) || parseFloat(this.form.loanTerm) <= 0) {
                this.form.errors.loanTerm = 'Please enter a valid loan term in years.';
            }

            if (!this.form.annualRate || isNaN(this.form.annualRate) || parseFloat(this.form.annualRate) <= 0) {
                this.form.errors.annualRate = 'Please enter a valid annual interest rate.';
            }

            return Object.keys(this.form.errors).length === 0;
        },

        submit() {
            if (!this.validateForm()) return;

            this.form.loading = true;
            setTimeout(() => {
                const homePrice = parseFloat(this.form.homePrice);
                const downPayment = parseFloat(this.form.downPayment);
                const loanTerm = parseFloat(this.form.loanTerm);
                const annualRate = parseFloat(this.form.annualRate);

                const loanPrincipal = homePrice - downPayment;
                const monthlyRate = (annualRate / 100) / 12;
                const totalPayments = loanTerm * 12;

                // Calculate monthly payment
                const monthlyPayment = (loanPrincipal * monthlyRate * Math.pow(1 + monthlyRate, totalPayments)) /
                    (Math.pow(1 + monthlyRate, totalPayments) - 1);

                this.result.monthlyPayment = monthlyPayment.toFixed(2);
                this.calculated = true;
                this.form.loading = false;
            }, 500); // Simulate processing delay
        },

        reset() {
            this.form.homePrice = '';
            this.form.downPayment = '';
            this.form.loanTerm = '';
            this.form.annualRate = '';
            this.calculated = false;
        },
    },
};
</script>

<style scoped>
@keyframes slideInLeft {
    from {
        transform: translateX(-100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

.slide-in-left {
    animation: slideInLeft 0.5s ease-in-out;
}
</style>
